import type { UserProfile } from '@factoryfixinc/ats-interfaces';

/** "Samantha K." style name for compact meta lines; falls back to whatever part exists. */
export const getUserShortName = (user?: UserProfile): string => {
  const first = user?.nameFirst?.trim() ?? '';
  const lastInitial = user?.nameLast?.trim().charAt(0) ?? '';

  if (first && lastInitial) {
    return `${first} ${lastInitial}.`;
  }

  return first || user?.nameLast?.trim() || '';
};
